import { render, staticRenderFns } from "./DrawingsCatalogList.vue?vue&type=template&id=2e3d1396"
import script from "./DrawingsCatalogList.vue?vue&type=script&lang=js"
export * from "./DrawingsCatalogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports